/* @flow */
import React from 'react';
import Authorization from './Authorization';
import { isPermitted } from './permissions';

export type AuthorizedForProjectProps = {
  permissions: [string],
  projectId: string,
  children: any
}

export default function AuthorizedForProject({
  permissions,
  projectId,
  children
}: AuthorizedForProjectProps): React.Element {
  return (
    <Authorization
      predicate={ userPrivileges => isPermitted(userPrivileges, permissions, projectId) }
    >
      { children }
    </Authorization>
  );
}
